const NotFound = () => (
  <div>
    <h2>404 – Nie znaleziono strony</h2>
    <p>Podana ścieżka nie istnieje.</p>
  </div>
);

export default NotFound;
